module.exports = __webpack_public_path__ + "media/lootbox_win_common.3d51323a.mp3";